module.exports = "<ngb-carousel class=\"full-carousel\" style=\"border:0; width: 100%\">\r\n  <ng-template ngbSlide  *ngFor=\"let slide of slides\">\r\n    <img src=\"{{slide.ximage}}\" alt=\"Random first slide\">\r\n    <div class=\"carousel-caption\">\r\n        <h3>{{slide.advertisment_name}}</h3>\r\n\r\n      <!-- <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> -->\r\n    </div>\r\n  </ng-template>\r\n</ngb-carousel>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/slider/slider.component.html
// module id = ./src/app/pages/home/slider/slider.component.html
// module chunks = main